import { Link } from "react-router-dom";
import { EyeIcon } from "../../components/Icons";
import { Badge } from "react-bootstrap";
import { formatMoney } from "../../utils/formatMoney";

export const tableData = (data, location) => {
  const columns = [
    // { field: "id", headerName: "ID", hide: true },
    {
      field: "fecha_creacion",
      headerName: "Fecha creación",
      minWidth: 220,
      //   flex: 0.1,
    },
    {
      field: "numero_recibo",
      headerName: "# Recibo",
      minWidth: 40,
      //   flex: 0.1,
    },
    {
      field: "acta_asociada",
      headerName: "Acta Asociada",
      minWidth: 70,
      //   flex: 0.1,
      //   renderCell: (params) => {
      //     return (
      //       <>
      //         <span
      //         //   bg={`${params.row.estado_id == 1 ? "primary" : params.row.estado_id == 3 ? "warning" : "success"}`}
      //           className={`${params.row.estado_id == 3 && "text-dark"}`}
      //         >
      //           {params.row.estado.toLowerCase()}
      //         </span>
      //       </>
      //     );
      //   },
    },
    {
      field: "monto",
      headerName: "Monto",
      minWidth: 100,
      //   flex: 0.1,
    },
    {
      field: "descuento",
      headerName: "Descuento",
      minWidth: 50,
      //   flex: 0.1,
    },
    {
      field: "fecha_pago",
      headerName: "Fecha pago",
      minWidth: 170,
      //   flex: 0.1,
    },
    // {
    //   field: "estado",
    //   headerName: "Scoring",
    //   minWidth: 130,
    // //   flex: 0.1,
    // },
    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 200,
      //   flex: 0.1,
      renderCell: (params) => {
        return (
          <>
            <div className="">
              <Link to={`${location.pathname}/${params.row.id}`} style={{ textDecoration: "none" }}>
                <EyeIcon /> Ver
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const rows = data?.map((d, index) => {
    return {
      id: d.id,
      fecha_creacion: d.created_at,
      numero_recibo: d.numero_recibo,
      acta_asociada: `${d.acta.dependencia} ${d.acta.numero_acta}`,
      monto: formatMoney(d.monto),
      descuento: d.descuento,
      fecha_pago: d.fecha_pago,
      //   documento: d.documento_titular,
      //   estado: d.estado?.descripcion,
      //   estado_id: d.estado_id,
      // fecha_notificacion: d.fecha_notificacion,
      // numero_acta: d.dependencia + "-" + d.numero_acta,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return String(d.numero_recibo)?.toString().toLowerCase().includes(value);
    //   String(d.plate)?.toString().toLowerCase().includes(value) ||
    //   String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
    //   String(d.infraccion)?.toString().toLowerCase().includes(value) ||
    //   String(d.documento)?.toString().toLowerCase().includes(value) ||
    //   String(d.localidad)?.toString().toLowerCase().includes(value) ||
    //   String(d.numero_acta)?.toString().toLowerCase().includes(value)
  };

  return { columns, rows, filter };
};
